import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    pageHeading: {
      fontSize: theme.typography.pxToRem(20),
      color: "#000",
      lineHeight: "28px",
    },
    backdrop: {
      zIndex: theme.zIndex.modal + 1,
      color: "#fff",
    },
    ".hidden": {
      overflow: "hidden",
    },

    cardMainParent: {
      float: "left",
      width: "100%",
    },
    tabCard: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      boxShadow: "none",
      borderRadius: "0px",
      borderRight: `1px solid ${theme.palette.divider}`,
    },
    tabCardContent: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      boxShadow: "none",
      borderRadius: "0px",
    },
    cardMain: {
      marginBottom: "30px",
      paddingTop: "10px",
      width: "calc(100%)",
    },
    subHeadings: {
      fontSize: "14px",
    },
    rightSubHeadings: {
      fontSize: "13px",
      margin: "6px 0",
    },
    subHeadingDisable: {
      color: "#A7A7A7",
    },
    subStatus: {
      fontSize: "14px",
      color: "#72CA00",
      display: "flex",
    },
    subStatusPending: {
      color: "#FF8800 !important",
    },
    subStatusCancel: {
      color: "#FF0C0C !important",
    },
    cusDivider: {
      width: "100%",
      marginLeft: "18px",
    },
    gateOutButton: {
      marginTop: "20px",
      padding: "8px ",
      fontSize: "12px",
    },
    noPadding: { paddingTop: "5px !important" },
    subDetails: {
      fontWeight: "bold",
      marginTop: "5px",
      marginRight: "5px",
      // marginLeft: "10px"
    },
    // iconClass: {},
    iconClass: {
      position: "relative",
      fontStyle: "normal",
    },
    insideIcon: { position: "absolute", top: "0px", left: "0px", width: "24px", height: "24px" },
    insideStatus: { paddingLeft: "30px", lineHeight: "25px", display: "block" },
    topButton: {
      position: "relative",
      top: "3px",
      background: "none",
      color: "#488CFB",
      border: "2px solid #488CFB",
      width: "96px",
      height: "32px",
      fontSize: "12px",
    },
    paidAmount: {
      color: "#72CA00",
      fontSize: "14px",
    },
    arrears: {
      color: "red",
      fontSize: "14px",
    },
    bydSwitchRow: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(1),
      marginTop: theme.spacing(1),
    },
    bydSwitchLabel: {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightMedium,
      color: "#000",
    },
    multiselectConfigFileCompression: {
      position: "relative",
      paddingLeft: "4px",
      "& .searchWrapper": {
        border: "none",
        maxHeight: "35px",
        overflow: "auto",
      },
      "& ::placeholder": {
        color: "#bcbcbc",
      },
    },
  })
);
